import React from 'react'
import { createStyles, makeStyles, AppBar } from '@material-ui/core'
import { MOBILE_HEADER_HEIGHT } from 'src/mobile/utils/constant'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      top: theme.spacing(MOBILE_HEADER_HEIGHT + 4),
      backgroundColor: theme.palette.background.paper,

      [theme.breakpoints.down('xs')]: {
        top: theme.spacing(MOBILE_HEADER_HEIGHT),
      },
    },
  }),
)

const TopStickyBar = ({ children }) => {
  const classes = useStyles()

  return (
    <AppBar elevation={0} position="none" className={classes.root}>
      {children}
    </AppBar>
  )
}

export default TopStickyBar
